// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.overlay[data-v-0bf82982] {
    background-color: rgba(0, 0, 0, 0);
    height: 100%;
    left: 0px;
    position: fixed;
    top: 0px;
    transition: background-color 0.35s cubic-bezier(0.645, 0.045, 0.355, 1),
        visibility 0.35s cubic-bezier(0.645, 0.045, 0.355, 1);
    visibility: hidden;
    width: 100%;
    z-index: 10;
}
.overlay.visible[data-v-0bf82982] {
    background-color: rgba(30, 30, 30, 0.6);
    visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./src/components/overlay/overlay.vue"],"names":[],"mappings":";AAKA;IACI,kCAAkC;IAClC,YAAY;IACZ,SAAS;IACT,eAAe;IACf,QAAQ;IACR;6DACyD;IACzD,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;AAEA;IACI,uCAAuC;IACvC,mBAAmB;AACvB","sourcesContent":["<template>\r\n    <div class=\"overlay\" v-bind:class=\"{ visible: isVisible }\" />\r\n</template>\r\n\r\n<style scoped>\r\n.overlay {\r\n    background-color: rgba(0, 0, 0, 0);\r\n    height: 100%;\r\n    left: 0px;\r\n    position: fixed;\r\n    top: 0px;\r\n    transition: background-color 0.35s cubic-bezier(0.645, 0.045, 0.355, 1),\r\n        visibility 0.35s cubic-bezier(0.645, 0.045, 0.355, 1);\r\n    visibility: hidden;\r\n    width: 100%;\r\n    z-index: 10;\r\n}\r\n\r\n.overlay.visible {\r\n    background-color: rgba(30, 30, 30, 0.6);\r\n    visibility: visible;\r\n}\r\n</style>\r\n\r\n<script>\r\nexport const Overlay = {\r\n    data: function() {\r\n        return {\r\n            isVisible: false\r\n        };\r\n    },\r\n    methods: {\r\n        show: function() {\r\n            this.isVisible = true;\r\n        },\r\n        hide: function() {\r\n            this.isVisible = false;\r\n        }\r\n    }\r\n};\r\n\r\nexport default Overlay;\r\n</script>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
